<template>
	<div class="tab_box">
      <!-- 可编辑的表格 -->
	    <vxe-table
          border
          resizable
          show-overflow
          ref="purchOrderreapdtl"
          :data="detailData"
          :edit-config="{trigger: 'click', mode: 'cell'}">
          <vxe-table-column  type="checkbox" width="40"></vxe-table-column>
          <vxe-table-column field="materialCode" title="物料编码" ></vxe-table-column>
          <vxe-table-column field="materialDesc" title="物料描述" ></vxe-table-column>
          <vxe-table-column field="basicUnitDesc" title="计量单位"></vxe-table-column>
          <vxe-table-column field="factoryDesc" title="工厂描述" ></vxe-table-column>
          <vxe-table-column field="inventoryDesc" title="库存地点"></vxe-table-column>
          <vxe-table-column field="batchNo" title="批次号"></vxe-table-column>
          <vxe-table-column field="materialGroup" title="物料组"></vxe-table-column>
          <vxe-table-column field="purchaseNum" title="订单数量" :edit-render="{name: 'input'}"></vxe-table-column>
          <vxe-table-column field="remainNum" title="剩余数量" :edit-render="{name: 'input'}"></vxe-table-column>
          <vxe-table-column field="returnQuantity" title="退货数量" :edit-render="{name: 'input'}"></vxe-table-column>
          <vxe-table-column field="netPrice" title="销售单价" :edit-render="{name: 'input'}"></vxe-table-column>
          <vxe-table-column field="inputTax" title="销项税(%)" :edit-render="{name: 'input'}"></vxe-table-column>
      </vxe-table>
  </div>
</template>

<script>
export default {
      data(){
        return {
           detailData:[],
           PurchOrderList:[]
        }
      },
      methods:{
          onSubmitSaves(){
              this.PurchOrderList = this.$refs.purchOrderreapdtl.getCheckboxRecords();
              // console.log(this.PurchOrderList,'== 444 ==');
          }
      }
}
</script>

<style scoped>

</style>